<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-部门-添加
    -->
    <el-dialog
    title="添加部门"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

       <el-form 
        ref="formRef" 
        :model="form" 
        :rules="rules" 
        label-width="100px"
        size="small"
      >
        <el-form-item label="上级部门" prop="parent_id">
          <el-cascader
            v-model="form.parent_id"
            :options="departmentTree"
            :props="{ 
              value: 'ma_depart_id', 
              label: 'name', 
              children: 'children',
              checkStrictly: true,
              emitPath: false
            }"
            clearable
            style="width: 100%;"
            placeholder="请选择上级部门（不选则为顶级部门）"
          ></el-cascader>
        </el-form-item>
        
        <el-form-item label="部门名称" prop="name">
          <el-input 
            v-model="form.name" 
            placeholder="请输入部门名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        
        <el-form-item label="部门职能" prop="remark">
          <el-input 
            v-model="form.remark" 
            type="textarea"
            :rows="16"
            placeholder="请输入部门职能描述"
            maxlength="3000"
            show-word-limit
          ></el-input>
        </el-form-item>
        

        
        <el-form-item label="是否隐藏" prop="is_hide">
          <el-switch
            v-model="form.is_hide"
            :active-value="1"
            :inactive-value="0"
            active-text="隐藏"
            inactive-text="显示"
          ></el-switch>
        </el-form-item>

        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc" />
  </div>
</el-dialog>
  
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      // 部门树形数据
      departmentTree: [],
      /*是否上传图片*/
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        parent_id: 0,
        name: '',
        remark: '',
        image: [],
        bannar: [],
        intro: '',
        sort: 50,
        is_hide: 0,
        status: 1
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入部门职能', trigger: 'blur' }]
      },
      dialogVisible: false,
      isProductUpload: false,
      uploadType: 'image',
      code: "image"
    };
  },
  created() {
    this.getDepartmentTree();
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    // 获取部门树形数据 - 使用通用API
    async getDepartmentTree() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.buildDepartmentTree(response.data.list.data || []);
        }
      } catch (error) {
        console.error('获取部门树失败:', error);
      }
    },
    
    // 构建部门树形结构
    buildDepartmentTree(departments) {
      const tree = [];
      const map = {};
      
      // 创建映射
      departments.forEach(dept => {
        map[dept.ma_depart_id] = { ...dept, children: [] };
      });
      
      // 构建树
      departments.forEach(dept => {
        const node = map[dept.ma_depart_id];
        if (dept.parent_id === 0) {
          tree.push(node);
        } else if (map[dept.parent_id]) {
          map[dept.parent_id].children.push(node);
        }
      });
      
      this.departmentTree = tree;
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc() { // 取消
      this.dialogFormVisible("error")
    },

    // 提交表单 - 使用通用API
    async onSubmit() {
      // 验证表单
      try {
        await this.$refs.formRef.validate();
      } catch (error) {
        return;
      }
      
      try {
        this.loading = true;
        
        // 处理图片字段
        const formData = {
          ...this.form,
          // 处理图片路径
          image: this.form.image.map(img => img.file_path || img).join(','),
          bannar: this.form.bannar.map(img => img.file_path || img).join(','),
          // 设置时间戳
          create_time: Math.floor(Date.now() / 1000),
          update_time: Math.floor(Date.now() / 1000)
        };
        
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'add',
          ...formData
        });
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加成功');
          this.dialogFormVisible("success");
        } else {
          this.$message.error(response.msg || '添加失败');
        }
      } catch (error) {
        console.error('添加失败:', error);
        this.$message.error('添加失败');
      } finally {
        this.loading = false;
      }
    },

    /*打开上传图片*/
    openProductUpload(type) {
      this.uploadType = type;
      this.isProductUpload = true;
      this.code = type === 'image' ? 'image' : 'bannar';
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if (!e || e.length === 0) {
        this.isProductUpload = false;
        return;
      }
      
      // 验证图片格式
      const imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      const invalidFiles = e.filter(element => {
        const data_array = element.file_path.split(".");
        const ext = data_array[data_array.length - 1].toLowerCase();
        return !imgExpt.includes(ext);
      });
      
      if (invalidFiles.length > 0) {
        this.$message.error("图片类型有误，请选择正确的图片格式");
        this.isProductUpload = false;
        return;
      }
      
      // 添加到对应的图片数组
      if (this.uploadType === 'image') {
        this.form.image = this.form.image.concat(e);
      } else if (this.uploadType === 'bannar') {
        this.form.bannar = this.form.bannar.concat(e);
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index, type) {
      if (type === 'image') {
        this.form.image.splice(index, 1);
      } else if (type === 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style scoped>
.product-add {
  padding: 20px;
}

.pb50 {
  padding-bottom: 50px;
}

.upload-section {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
  background: #F5F7FA;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  overflow: hidden;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 2px;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}

.el-form-item {
  margin-bottom: 15px;
}

::v-deep .el-textarea__inner {
  font-family: inherit;
  line-height: 1.5;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_depart/index/part/add.vue